import { formatDocumentTitle } from './document-title';

const PUBLIC_ORIGIN = 'https://nexotcg.com';
const DEFAULT_DESCRIPTION = 'Compre e venda cartas de TCG, encontre impressões e organize seu deck na Nexo.';

export const applyPageMetadata = (title?: string, pathname = window.location.pathname, description = DEFAULT_DESCRIPTION) => {
  const canonical = new URL(pathname, PUBLIC_ORIGIN);
  canonical.search = '';
  canonical.hash = '';
  document.title = formatDocumentTitle(title);

  const values = [
    ['name', 'description', description],
    ['property', 'og:title', document.title],
    ['property', 'og:description', description],
    ['property', 'og:url', canonical.href],
    ['property', 'og:type', 'website'],
  ];

  values.forEach(([attribute, name, content]) => {
    const meta = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`) ?? document.createElement('meta');
    meta.setAttribute(attribute, name);
    meta.content = content;

    if (!meta.isConnected) {
      document.head.append(meta);
    }
  });

  const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]') ?? document.createElement('link');
  link.rel = 'canonical';
  link.href = canonical.href;

  if (!link.isConnected) {
    document.head.append(link);
  }
};
